export const HELP_TO_ACCESS_PATH =
  'https://central.arvore.com.br/central/suporte'
